const locales = {
  langs: ['en-my', 'pt-br', 'es-pe', 'es-cl'],
  defaultLangKey: 'es-pe'
}

module.exports = locales
